import script from "./HomeHero.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeHero.vue?vue&type=script&setup=true&lang=js"

import "./HomeHero.vue?vue&type=style&index=0&id=711e9752&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-711e9752"]])

export default __exports__